import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createSlots as _createSlots, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "q-mt-lg row justify-center" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "row justify-center q-my-md" };
const _hoisted_4 = { class: "q-mt-lg q-mb-md annotation-text" };
const _hoisted_5 = { class: "copyright" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_img = _resolveComponent("q-img");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_router_link = _resolveComponent("router-link");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_footer = _resolveComponent("q-footer");
    const _component_q_page = _resolveComponent("q-page");
    const _component_q_page_container = _resolveComponent("q-page-container");
    const _component_q_layout = _resolveComponent("q-layout");
    return (_openBlock(), _createBlock(_component_q_layout, {
        view: "lHh Lpr lFf",
        class: "login-page responsive-back-img"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_q_page_container, { class: "row" }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_page, { class: "col no-wrap items-center" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(_component_q_card, { class: "q-ma-md login-box col-10 col-sm-8 col-md-4" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_card_section, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_img, {
                                                    src: "icons/top_logo.png",
                                                    class: "responsive-img",
                                                    fit: "scale-down"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_q_card_section, null, {
                                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                    _createElementVNode("div", { class: "text-h5 text-bold" }, "入居者様向けマイページ", -1)
                                                ]))]),
                                            _: 1
                                        }),
                                        (_ctx.isVisibleAnnounceRange)
                                            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", {
                                                        class: "q-pa-md",
                                                        innerHTML: _ctx.htmlAnnounceRange.value
                                                    }, null, 8, _hoisted_2)
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        _createVNode(_component_q_card_section, null, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                    _createVNode(_component_q_input, {
                                                        label: "ログインID",
                                                        color: "positive",
                                                        "stack-label": "",
                                                        autofocus: "",
                                                        modelValue: _ctx.data.loginId,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.data.loginId) = $event)),
                                                        error: _ctx.valid.loginId.error,
                                                        "error-message": _ctx.valid.loginId.message,
                                                        onKeyup: _withKeys(_ctx.login, ["enter"])
                                                    }, _createSlots({ _: 2 }, [
                                                        (_ctx.data.loginId)
                                                            ? {
                                                                name: "append",
                                                                fn: _withCtx(() => [
                                                                    _createVNode(_component_q_icon, {
                                                                        name: "cancel",
                                                                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.data.loginId = null), ["stop"])),
                                                                        class: "cursor-pointer"
                                                                    })
                                                                ]),
                                                                key: "0"
                                                            }
                                                            : undefined
                                                    ]), 1032, ["modelValue", "error", "error-message", "onKeyup"]),
                                                    _createVNode(_component_q_input, {
                                                        label: "パスワード",
                                                        type: "password",
                                                        autocomplete: "off",
                                                        color: "positive",
                                                        "stack-label": "",
                                                        modelValue: _ctx.data.password,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.data.password) = $event)),
                                                        error: _ctx.valid.password.error,
                                                        "error-message": _ctx.valid.password.message,
                                                        onKeyup: _withKeys(_ctx.login, ["enter"])
                                                    }, _createSlots({ _: 2 }, [
                                                        (_ctx.data.password)
                                                            ? {
                                                                name: "append",
                                                                fn: _withCtx(() => [
                                                                    _createVNode(_component_q_icon, {
                                                                        name: "cancel",
                                                                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.data.password = null), ["stop"])),
                                                                        class: "cursor-pointer"
                                                                    })
                                                                ]),
                                                                key: "0"
                                                            }
                                                            : undefined
                                                    ]), 1032, ["modelValue", "error", "error-message", "onKeyup"])
                                                ]),
                                                _createElementVNode("div", _hoisted_3, [
                                                    _createVNode(_component_q_btn, {
                                                        label: "ログイン",
                                                        color: "green-7",
                                                        class: "btn-route col",
                                                        disable: _ctx.busy,
                                                        onClick: _ctx.login
                                                    }, null, 8, ["disable", "onClick"])
                                                ]),
                                                _createElementVNode("div", _hoisted_4, [
                                                    _createVNode(_component_router_link, { to: { name: 'password-reissue-entry' } }, {
                                                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                                _createTextVNode("パスワードを忘れた場合", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createVNode(_component_q_separator),
                                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "q-mt-md annotation-text" }, [
                                                    _createElementVNode("div", { style: { "text-align": "left" } }, [
                                                        _createTextVNode("ご連絡事項 "),
                                                        _createElementVNode("br"),
                                                        _createTextVNode(" ミニミニでのご契約者様は、ミニミニマイページと同じID・パスワードでログインができます。 ミニミニマイページの初期設定がまだのお客様は下記ページより、ご契約時にお渡しした書類に記載されているログインID・パスワードを入力し、初期設定をしてください。")
                                                    ]),
                                                    _createElementVNode("a", {
                                                        href: "https://minimini.jp/customer",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer"
                                                    }, "ミニミニマイページはこちら")
                                                ], -1))
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createVNode(_component_q_footer, {
                                bordered: "",
                                class: "bg-white text-black"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.copyright), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }));
}
